import AsyncSearchSelect from '../async-search-select'
import requests from 'service/api'
import { asOptions, asRows, firstOption } from 'lib/asyncList'

export function ReferanceAsyncSelect({
  name,
  label = 'Referans Kodu',
  labelCategory,
  value,
  valueField = 'id',
  extraFilter,
  onChange,
}) {
  const mapItem = (item) => ({
    value: valueField === 'code' ? item.code : item.id,
    label: item.code,
  })

  const applyFilter = (options) =>
    extraFilter ? options.filter((option) => extraFilter(option)) : options

  return (
    <AsyncSearchSelect
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      fetchSelected={async (selected) => {
        if (valueField === 'code') {
          return firstOption(
            requests.referance.list({ code: selected, labelCategory }),
            mapItem
          )
        }
        const byId = await firstOption(requests.referance.get(selected), mapItem)
        if (byId) return byId
        return firstOption(requests.referance.list({ selected }), mapItem)
      }}
      fetchOptions={async (search) => {
        const options = await asOptions(
          requests.referance.list({ search, labelCategory, limit: 20 }),
          mapItem
        )
        return applyFilter(options)
      }}
    />
  )
}

export async function searchReferanceRows({ search, labelCategory, limit = 20 }) {
  return asRows(requests.referance.list({ search, labelCategory, limit }))
}
